<script setup lang="ts">
import { useSpaceEventHandler } from '@collector/shared-ui'
import EventClockMinuteInput from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/EventClockMinuteInput.vue'
import EventClockPlayPauseButton from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/EventClockPlayPauseButton.vue'
import EventClockSecondInput from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/EventClockSecondInput.vue'
import { useEventClock } from '@desktop/views/Relation/Sports/composables'

import SecondAdjustButton from './SecondAdjustButton.vue'

const { isClockRunning, updateEventClockRunning } = useEventClock()

useSpaceEventHandler(updateEventClockRunning)
</script>

<template>
  <div class="flex justify-center gap-x-2">
    <div class=""></div>
    <div class="flex gap-x-2">
      <SecondAdjustButton :second="-5" />
      <SecondAdjustButton :second="-1" />
      <div class="flex items-center gap-x-0.5">
        <EventClockMinuteInput
          inputClass="w-11 border-neutral-light-0 focus-within:border-neutral-dark-0 text-center"
        />
        <span>:</span>
        <EventClockSecondInput
          inputClass="w-11 border-neutral-light-0 focus-within:border-neutral-dark-0 text-center"
        />
      </div>
      <SecondAdjustButton :second="1" />
      <SecondAdjustButton :second="5" />
    </div>
    <div class="-mr-8">
      <EventClockPlayPauseButton
        class="text-neutral-light-10"
        :class="{
          'bg-error-6 border-error-6': !isClockRunning,
          'bg-success-2 border-success-2': isClockRunning,
        }"
        square
        size="sm"
      />
    </div>
  </div>
</template>
